import {
    temAcesso
} from '@/shared/auth/temAcesso'

const SolicitacoesAcesso = () => import('./SolicitacoesAcesso.vue')
const SolicitacaoAcessoDetalhar = () => import('./SolicitacaoAcessoDetalhar.vue')

export default {
    path: 'solicitacoesacesso',
    name: 'SolicitacoesAcesso',
    component: SolicitacoesAcesso,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-SOLACS-00')) {
            next()
        }
    },
    children: [{
        path: ':solicitacaoAcessoId',
        name: 'SolicitacoesAcesso_Detalhar',
        component: SolicitacaoAcessoDetalhar,
        beforeEnter: (to, from, next) => {
            if (temAcesso('CTRLACS-SOLACS-01')) {
                next()
            }
        }
    }]
}
